import React, { Component } from 'react'
import { ResponsiveBar } from '@nivo/bar'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core/'
import { Scrollbars } from 'react-custom-scrollbars'

class BarChart extends Component {
  render() {
    const {
      appraisal_type_id,
      company_id,
      // emp_id,
      form_id,
      // level_group_id,
      org_id,
      position_id,
      structure_id
    } = this.props.filterControls
    /**
     * Returns a tick element that wraps text for the given number of lines and adds an ellipsis if the text can't fit. This can be passed to the renderTick method.
     */
    // const HorizontalTick = ({ textAnchor, textBaseline, value, x, y }) => {
    //   const MAX_LINE_LENGTH = 25
    //   const MAX_LINES = 2
    //   const LENGTH_OF_ELLIPSIS = 3
    //   const TRIM_LENGTH = MAX_LINE_LENGTH * MAX_LINES - LENGTH_OF_ELLIPSIS
    //   const trimWordsOverLength = new RegExp(`^(.{${TRIM_LENGTH}}[^\\w]*).*`)
    //   const groupWordsByLength = new RegExp(`([^\\s].{0,${MAX_LINE_LENGTH}}(?=[\\s\\W]|$))`, 'gm')
    //   const splitValues = value
    //     .replace(trimWordsOverLength, '$1...')
    //     .match(groupWordsByLength)
    //     .slice(0, 2)
    //     .map((val, i) => (
    //       <tspan key={val} dy={12 * i} x={-10} style={{ fontSize: 11 }}>
    //         {val}
    //       </tspan>
    //     ))
    //   return (
    //     <g transform={`translate(${x},${y})`}>
    //       <text alignmentBaseline={textBaseline} textAnchor={textAnchor}>
    //         {splitValues}
    //       </text>
    //     </g>
    //   )
    // }

    let name = []
    let value = []
    let dataAll = []

    if (this.props.barChart) {
      // ฟังก์ชัน Object.values ใช้แปลง value จาก Object เป็น array เพื่อให้ใช้ function map ได้
      name = Object.values(this.props.barChart || []).map(item => {
        return item.name
      })
      dataAll.push(this.props.barChart || [])
    }

    if (this.props.percentChange) {
      value = Object.values(this.props.percentChange || []).map(item => {
        return item.value
      })
      dataAll.push(this.props.percentChange || [])
    }

    let dataBarChart = []

    // map เพื่อเอา value จาก percentChange มาใส่ใน dataBarChart
    dataBarChart = dataAll[0].map((item, index) => {
      return {
        ...item,
        value: value[index]
      }
    })

    return (
      <Scrollbars>
        <Table size='small' stickyHeader>
          <TableHead>
            <TableRow hover>
              <TableCell width='38%' />
              <TableCell width='60%' />
              <TableCell width='2%' align='center'>
                %Change
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataBarChart.map((row, index) => (
              <TableRow key={index} hover>
                {/* Bar Chart */}
                <TableCell>
                  <p style={{ fontSize: 11 }}>{row.name}</p>
                </TableCell>
                <TableCell align='right'>
                  <div
                    style={{
                      height: 60,
                      maxWidth: 500
                    }}>
                    <ResponsiveBar
                      data={[row]}
                      keys={name}
                      onClick={() => {
                        // alert(JSON.stringify(row.id))
                        // let find_id = JSON.stringify(JSON.parse(Object.values({ id })))
                        let find_id = row.id
                        let param = {
                          appraisal_type_id: appraisal_type_id.value?.value,
                          form_id: form_id?.value?.value,
                          org_id: org_id?.value?.value,
                          company_id: company_id?.value?.value,
                          structure_id: structure_id?.value?.value,
                          position_id: position_id?.value?.value,
                          find_id: find_id
                        }
                        this.props.fetchDashboardPerformanceComparisonDataKpi(param)
                      }}
                      // borderRadius={20}
                      indexBy='name'
                      margin={{ top: 10, bottom: 10, left: 0, right: 0 }}
                      padding={0.3}
                      minValue={0}
                      maxValue={100}
                      layout='horizontal'
                      colors={{ scheme: 'nivo' }}
                      defs={[
                        {
                          id: 'lines',
                          type: 'patternLines',
                          background: 'inherit',
                          color: '#eed312',
                          rotation: -45,
                          lineWidth: 5,
                          spacing: 10
                        }
                      ]}
                      fill={[
                        {
                          match: {
                            id: row.name
                          },
                          id: 'lines'
                        }
                      ]}
                      borderColor={{
                        from: 'color',
                        modifiers: [['darker', 1.6]]
                      }}
                      axisTop={null}
                      axisRight={null}
                      axisBottom={null}
                      axisLeft={null}
                      // axisLeft={{
                      //   tickSize: 8,
                      //   tickPadding: 5,
                      //   tickRotation: 0,
                      //   legendPosition: 'middle',
                      //   legendOffset: -40,
                      //   renderTick: HorizontalTick
                      // }}
                      labelSkipWidth={12}
                      labelSkipHeight={12}
                      labelTextColor={{
                        from: 'color',
                        modifiers: [['darker', 1.6]]
                      }}
                      animate={true}
                      motionStiffness={90}
                      motionDamping={15}
                    />
                  </div>
                </TableCell>
                <TableCell align='center'>{row.value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Scrollbars>
    )
  }
}

export default BarChart
